import axios from "axios";
import CONFIG from "../config";
import { attachAuthInterceptor } from "./authInterceptor";

const flaskApi = axios.create({
  baseURL: CONFIG.SMART_TOOLS_URL,
});

// Refresh goes to core-service, not smart-tools.
attachAuthInterceptor(flaskApi, { refreshBaseUrl: CONFIG.EMPLOYEE_SERVICE_URL });

export default flaskApi;
